<template>
  <section class="mc-rec-section mc-rec-fade-enter-active">
    <h2 class="mc-rec-section__title">Resumo desde a ativação</h2>
    <p class="mc-rec-section__desc">Dados acumulados desde a ativação da funcionalidade</p>

    <div v-if="loading" class="text-center py-5">
      <b-spinner style="color: #5b028c;" />
    </div>
    <template v-else-if="dados">
      <div class="mc-rec-hero">
        <div class="mc-rec-hero__label">Receita total gerada</div>
        <div class="mc-rec-hero__value">R$ {{ formatarMoeda(dados.receita) }}</div>
      </div>
      <div class="mc-rec-metric-grid">
        <div class="mc-rec-metric">
          <div class="mc-rec-metric__label">Pedidos totais</div>
          <div class="mc-rec-metric__value">{{ dados.pedidos }}</div>
        </div>
        <div class="mc-rec-metric">
          <div class="mc-rec-metric__label">ROI acumulado</div>
          <div class="mc-rec-metric__value">{{ dados.roiTexto }}</div>
        </div>
        <div class="mc-rec-metric">
          <div class="mc-rec-metric__label">Conversão acumulada</div>
          <div class="mc-rec-metric__value">{{ dados.conversao }}</div>
        </div>
        <div class="mc-rec-metric">
          <div class="mc-rec-metric__label">Clientes reativados</div>
          <div class="mc-rec-metric__value">{{ dados.clientes }}</div>
        </div>
      </div>
      <p class="mt-3 mb-0 px-1" style="font-size: 0.9375rem; color: #6e6781; line-height: 1.5;">
        Desde a ativação, as recomendações via WhatsApp geraram
        <strong style="color: #221c35;">R$ {{ formatarMoeda(dados.receita) }}</strong> em receita,
        <strong style="color: #221c35;">{{ dados.pedidos }}</strong> pedidos e reativaram
        <strong style="color: #221c35;">{{ dados.clientes }}</strong> clientes.
      </p>
    </template>
  </section>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'

export default {
  name: 'RecommendationLifetimeSummary',
  components: { BSpinner },
  props: {
    loading: Boolean,
    dados: { type: Object, default: null },
  },
  methods: {
    formatarMoeda(val) {
      if (val == null || val === '') return '0,00'
      const n = parseFloat(val)
      return Number.isNaN(n) ? '0,00' : n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
  },
}
</script>
